import { render, staticRenderFns } from "./BindRecord.vue?vue&type=template&id=514c6ddc&scoped=true"
import script from "./BindRecord.vue?vue&type=script&lang=js"
export * from "./BindRecord.vue?vue&type=script&lang=js"
import style0 from "./BindRecord.vue?vue&type=style&index=0&id=514c6ddc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514c6ddc",
  null
  
)

export default component.exports